module.exports = __webpack_public_path__ + "static/media/Shuckle_gaussian2.7e3000e8.png";